import React from 'react';
import { Button, Form, Col, Row, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4"

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

class TrainingPaymentForm extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null || Object.keys(props.location.state.user).length === 0);
        console.log(props);
        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            event: props.location.state.event,
            registrants: props.location.state.registrants,
            subTotal: props.location.state.totalCost,
            totalAmount: props.location.state.totalCost,
            transaction: props.location.state.transaction,
            promoValid: false,
            promoText: '',
            paymentType: 'Credit',
            promoCode: '',
            forceRefreshVar: 0,
            loading: true,
            loadingPromo:false,
            loadingFree: false,
            embedURL: ''
        };
        this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);
        this.hideSpinner = this.hideSpinner.bind(this);
        this.applyPromoCode = this.applyPromoCode.bind(this);
        this.handlePromoChange = this.handlePromoChange.bind(this);
        this.showPromoButton = this.showPromoButton.bind(this);
        this.finalizeRegistrationFree = this.finalizeRegistrationFree.bind(this);
        this.showButton = this.showButton.bind(this);
    }

    componentDidMount() {

        ReactGA.event({
            category: 'Training',
            action: 'PaymentPage',
            label: 'Payment page reached'
        });
        this.setState({
            embedURL: this.state.transaction.url + '?key=' + this.state.transaction.key + '&token=' + this.state.transaction.token + '&ThemeName=ClientPortal_Training'
        });
    }

    finalizeRegistrationFree() {
        this.setState({
            loadingFree: true
        }, function () {
            axios.get(`${Constants.apiURL}/api/Payment/confirmRegistration`, {
                params: {
                    trxKey: this.state.transaction.key
                }
            }).then(response => {
                console.log(response);
                this.setState({ loadingFree: false });
                if (response.data.success != false) {
                    ReactGA.event({
                        category: 'Training',
                        action: 'FreeRegistration',
                        label: 'Training Event Free Registration'
                    });
                    if (this.state.userExists) {
                        alert('Success!')
                        this.props.history.push({
                            pathname: "/my_training",
                            state: {
                                user: this.state.user
                            }
                        });
                    }
                    else {
                        alert('Success!')
                        this.props.history.push({
                            pathname: "/training"
                        });
                    }
                }
            }).catch((response) => {
                this.setState({
                    loadingFree: false
                });
                alert('Error processing registration.');
            });
        });
    }

    applyPromoCode(event) {
        this.setState({
            loadingPromo: true
        }, function () {
            axios.get(`${Constants.apiURL}/api/Payment/apply_promo`, {
                params: {
                    trxKey: this.state.transaction.key,
                    promoCode: this.state.promoCode
                }
            }).then(response => {
                console.log(response);
                if (response.data.success != false) {
                    if (response.data.total == 0) {
                        this.setState({
                            loadingPromo: false,
                            totalAmount: response.data.total,
                            promoValid: true,
                            promoText: 'Promo applied: ' + response.data.text
                        });
                    }
                    else {
                        this.setState({
                            loadingPromo: false,
                            totalAmount: response.data.total,
                            promoValid: true,
                            promoText: 'Promo applied: ' + response.data.text
                        }, function () {
                            this.setState({
                                loading: true
                            }, function () {
                                axios.get(`${Constants.apiURL}/api/Payment/update`, {
                                    params: {
                                        key: this.state.transaction.key,
                                        type: this.state.paymentType,
                                        amount: this.state.totalAmount
                                    }
                                }).then(response => {
                                    console.log(response);
                                    if (response.data) {
                                        let trx = this.state.transaction;
                                        trx.token = response.data.token;
                                        trx.key = response.data.key;
                                        this.setState({
                                            loading: false,
                                            transaction: trx,
                                            embedURL: response.data.url + '?key=' + response.data.key + '&token=' + response.data.token + '&ThemeName=ClientPortal_Training'
                                        });
                                    }
                                    else {
                                        this.setState({
                                            loading: false
                                        });
                                        alert('Error updating transaction.');
                                    }
                                }).catch((response) => {
                                    this.setState({
                                        loading: false
                                    });
                                    alert('Error updating transaction.');
                                });
                            });
                        });
                    }
                }
                else {
                    this.setState({
                        loadingPromo: false
                    });
                    alert('This code is not valid. Please contact marketing@boland.com with questions.');
                }
            }).catch((response) => {
                this.setState({
                    loadingPromo: false
                });
                alert('This code is not valid. Please contact marketing@boland.com with questions.');
            });
        });
    }

    handlePromoChange(event) {
        this.setState({
            promoCode: event.target.value
        });
    }

    handlePaymentTypeChange(event) {
        this.setState({
            loading: true,
            paymentType: event.target.value
        }, function () {
            axios.get(`${Constants.apiURL}/api/Payment/update`, {
                params: {
                    key: this.state.transaction.key,
                    type: event.target.value,
                    amount: this.state.totalAmount
                }
            }).then(response => {
                console.log(response);
                if (response.data) {
                    let trx = this.state.transaction;
                    trx.token = response.data.token;
                    trx.key = response.data.key;
                    this.setState({
                        loading: false,
                        transaction: trx,
                        embedURL: response.data.url + '?key=' + response.data.key + '&token=' + response.data.token + '&ThemeName=ClientPortal_Training'
                    });
                }
                else {
                    this.setState({
                        loading: false
                    });
                    alert('Error updating transaction, please contact us at marketing@boland.com if this issue persists.');
                    this.props.history.push({
                        pathname: "/training",
                        state: {
                            user: this.state.user
                        }
                    });
                }
            }).catch((response) => {
                this.setState({
                    loading: false
                });
                alert('Error updating transaction, please contact us at marketing@boland.com if this issue persists.');
                this.props.history.push({
                    pathname: "/training",
                    state: {
                        user: this.state.user
                    }
                });
            });
        });
    }

    hideSpinner() {
        this.setState({
            loading: false
        });
    }

    showButton() {
        if (this.state.loadingFree) {
            return <Button hidden={this.state.totalAmount > 0} style={{ backgroundColor: '#1F419B', width: 'auto', marginLeft: '10px' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ margin: 10, backgroundColor: '#1F419B', width: 'auto' }} hidden={this.state.totalAmount > 0} onClick={this.finalizeRegistrationFree}>Finalize Registration</Button>
        }
    }
    showPromoButton() {
        if (this.state.loadingPromo) {
            return <Button style={{ backgroundColor: '#1F419B', width: 'auto', marginLeft: '10px' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ width: 'auto', marginLeft: '10px' }} onClick={this.applyPromoCode}>Apply</Button>
        }
    }

    render() {
        const columns = [
        ];
        return (
            <div class="training_payment">
                {this.state.userExists ? <SiteMenu user={this.state.user} currentPage='invoicePayment' /> : <GuestSiteMenu currentPage='invoicePayment' />}
                <Row>
                    <Form.Label className="form-header" style={{ padding: '10px 0px 0px 30px', marginBottom: 0 }}>Registration Confirmation & Payment</Form.Label>
                </Row>
                <Row style={{ marginLeft: '10px' }}>
                    <Form.Label> <b>Event:</b> {this.state.event.Name}</Form.Label>
                </Row>
                <Row style={{ marginLeft: '10px' }}>
                    <Form.Label><b>Quantity:</b> {this.state.registrants.length}</Form.Label>
                </Row>
                <Row style={{ marginLeft: '10px' }}>
                    <Form.Label><b>Subtotal:</b> ${this.state.subTotal}</Form.Label>
                </Row>
                <Row style={{ marginLeft: '10px' }}>
                    <Form.Label> <b>Discount:</b> -${(this.state.subTotal - this.state.totalAmount).toFixed(2)}</Form.Label>
                </Row>
                <Row style={{ marginLeft: '10px' }}>
                    <Form.Label> <b>Total:</b> ${(this.state.totalAmount - 0.00).toFixed(2)}</Form.Label>
                </Row>
                <Row style={{ marginLeft: '10px' }}>
                    <Form.Control style={{ width: '200px' }} type="text" name="promoCode" value={this.state.promoCode} onChange={this.handlePromoChange} placeholder='Enter promo code' />
                    {this.showPromoButton()}
                    <Form.Label style={{ width: 'auto', marginLeft: '10px', marginTop:5 }} hidden={!this.state.promoValid}><b>{this.state.promoText}</b></Form.Label>
                </Row>
                {this.showButton()}
                <Row style={{ justifyContent: 'right' }} hidden={this.state.totalAmount == 0}>
                    <Col xs='auto' sm='auto' md='auto'>
                        <Form.Label style={{ padding: '15px 0px 0px 15px', marginBotton: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 16 }}>
                            Payment Type:
                        </Form.Label>
                    </Col>
                    <Col xs='auto' sm='auto' md='auto'>
                        <Form.Select onChange={this.handlePaymentTypeChange} name="paymentType" size="sm" style={{ margin: '14px 0px 0px 0px', width: '180px', verticalAlign: 'middle' }}>
                            <option value="Credit">Credit Card</option>
                            <option value="eCheck">ACH / eCheck</option>
                        </Form.Select>
                    </Col>
                    <Col width='100%' />
                </Row>
                <Form.Label hidden={this.state.totalAmount == 0 } style={{ padding: '5px 0px 0px 15px', marginBotton: 0, verticalAlign: 'middle', fontStyle: 'italic', color: '#FF0000', fontSize: '14px', fontWeight: '500' }}>There is a 2.5% surcharge on all Credit Card payments.  There is no fee for Debit Card or EFT Payments.</Form.Label>
                <div hidden={this.state.totalAmount == 0} style={{ backgroundColor: '#f7f7f7', width: '850px', height: '800px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center' }}>

                    {this.state.loading ? (<Spinner
                        style={{ alignSelf: 'center' }}
                        animation="border"
                        role="status"
                        aria-hidden="true"
                    />
                    ) : null}
                    <iframe class="payment_iframe" hidden={this.state.loading} onLoad={this.hideSpinner} style={{ width: '850px', height: '100%' }} src={this.state.embedURL} key={this.state.forceRefreshVar} />
                </div>
            </div>
        );
    }
}

export default TrainingPaymentForm;